<div *ngIf="!newSelectPatron.data" fxLayout="column" fxLayoutAlign="center center">
  <mat-spinner strokeWidth="5" color="accent" [diameter]="25"></mat-spinner>
</div>

<div
  *ngIf="newSelectPatron.data"
  fxLayout="column"
  fxLayoutAlign="start center"
  class="width-100 ag-px-sm"
>
  <div fxFlex>
    <h5 *ngIf="hold">
      {{ hold ? 'Select a Patron' : 'SHAREit Lookup' }}
    </h5>
  </div>

  <div fxLayout="column" fxFlex>
    <form class="font-0-9" (ngSubmit)="searchPatrons()" fxLayoutGap="10px">
      <div fxLayout="column">
        <div fxLayout="column" fxFlex>
          <label *ngIf="isInSideNav" for="searchTerm" class="ag-mr-sm">Search Patron</label>
          <mat-form-field appearance="outline" [ngClass]="{ inSideNav: isInSideNav }" fxFlex>
            <mat-label *ngIf="!isInSideNav">Search Patron</mat-label>
            <input
              matInput
              type="text"
              id="searchTerm"
              placeholder="Search Patron"
              [disabled]="!canReserve"
              [(ngModel)]="searchTerm"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <div fxLayout="column" fxFlex="50">
            <label *ngIf="isInSideNav" for="selectSearchIndex" class="ag-mr-sm">
              Select Search Index
            </label>
            <mat-form-field appearance="outline" [ngClass]="{ inSideNav: isInSideNav }" fxFlex>
              <mat-label *ngIf="!isInSideNav">Select Search Index</mat-label>
              <mat-select
                id="selectSearchIndex"
                [(ngModel)]="searchIndex"
                [disabled]="!canReserve"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option
                  *ngFor="let patronIn of newSelectPatron?.data.patronIndicesList"
                  [value]="patronIn.code"
                >
                  {{ patronIn.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxLayout="column" fxFlex="50">
            <label *ngIf="isInSideNav" for="chooseUserGroup" class="ag-mr-sm">
              Choose User Group
            </label>
            <mat-form-field appearance="outline" [ngClass]="{ inSideNav: isInSideNav }" fxFlex>
              <mat-label *ngIf="!isInSideNav">Choose User Group</mat-label>
              <mat-select
                id="chooseUserGroup"
                [(ngModel)]="patronGroupId"
                [disabled]="!canReserve"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option
                  *ngFor="let patron of newSelectPatron.data.patronGroupsList; let i = index"
                  [value]="patron.groupID"
                  [attr.selected]="i === 0 ? true : null"
                >
                  {{ patron.groupName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center">
          <button
            mat-raised-button
            type="submit"
            class="ag-mat-button-primary"
            [disabled]="searching || !canReserve"
          >
            <mat-icon *ngIf="searching">
              <mat-spinner diameter="20"></mat-spinner>
            </mat-icon>
            Search
          </button>
          <button
            *ngIf="showCurrentPatron"
            mat-raised-button
            class="ag-mat-button-primary"
            type="button"
            (click)="currentPatron()"
          >
            Current Patron
          </button>
        </div>

        <div *ngIf="searchPatronResults" class="text-center ag-py-sm">
          <a
            tabindex="0"
            (agInteract)="getPrevPatrons()"
            [ngClass]="!hasPrevious ? 'disable-link' : 'pointer'"
          >
            <i class="fa fa-angle-left" aria-hidden="true"></i> Previous
          </a>
          <a
            tabindex="0"
            (agInteract)="getNextPatrons()"
            [ngClass]="!hasNext ? 'disable-link' : 'pointer'"
          >
            Next <i class="fa fa-angle-right" aria-hidden="true"> </i>
          </a>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="searchPatronResults" fxLayout="row" fxLayoutGap="10px" class="patron-listings card">
    <div
      *ngIf="searchPatronResults.patrons?.length; else noResultsTemplate"
      fxLayout="column"
      fxLayoutGap="10px"
      class="width-100"
    >
      <!-- Header Row -->
      <div class="ag-mb-sm" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <div fxFlex="30" fxLayoutGap="10px"><strong>Barcode</strong></div>
        <div fxFlex="20" fxLayoutGap="10px"><strong>Last Name</strong></div>
        <div fxFlex="20" fxLayoutGap="10px"><strong>First Name</strong></div>
        <div fxFlex="30" fxLayoutGap="10px"><strong>Address</strong></div>
      </div>

      <!-- Patron Rows -->
      <div
        *ngFor="let patron of searchPatronResults.patrons"
        class="ag-mb-sm pointer"
        fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="start center"
        (agInteract)="choosePatron(patron)"
      >
        <div fxFlex="30" fxLayoutGap="10px">{{ patron.barcode }}</div>

        <div fxFlex="20" fxLayoutGap="10px" class="truncate-ellipsis">{{ patron.lastName }}</div>

        <div fxFlex="20" fxLayoutGap="10px" class="truncate-ellipsis">{{ patron.firstName }}</div>

        <div fxFlex="30" fxLayoutGap="10px" class="truncate-ellipsis">{{ patron.address }}</div>
      </div>
    </div>

    <!-- No Results Template -->
    <ng-template #noResultsTemplate>
      <div fxLayoutAlign="center center">No patrons available</div>
    </ng-template>
  </div>

  <div *ngIf="searchPatronResults" fxLayoutAlign="center center" class="text-center ag-py-sm">
    <a
      tabindex="0"
      (agInteract)="getPrevPatrons()"
      [ngClass]="!hasPrevious ? 'disable-link' : 'pointer'"
    >
      <i class="fa fa-angle-left" aria-hidden="true"></i> Previous
    </a>
    <a
      tabindex="0"
      (agInteract)="getNextPatrons()"
      [ngClass]="!hasNext ? 'disable-link' : 'pointer'"
    >
      Next <i class="fa fa-angle-right" aria-hidden="true"> </i>
    </a>
  </div>
</div>
